<template>
  <div class="custom-margin-full-page">
      <global-snack-bar-mobile></global-snack-bar-mobile>
    <v-row>
      <v-col cols="12" class="title-courses">
        <img width="80px" class="custom-shape-circle-red-course" src="@/assets/shape-02.png" alt="red-circle">
        دوره های دُرَک
      </v-col>
      <v-col cols="12" v-for="course in courses" :key="course.id">
        <img class="custom-shape-red-course" src="@/assets/red-dots.png" alt="red-dots">
        <v-card elevation="0" class="course-card pa-3">
          <v-card-title class="text-center white-background">
            {{ course.title }}
          </v-card-title>
          <v-card-text class="white-background">
            <v-row>
              <v-col cols="12">
                <img class="course-cover" width="100%" height="200px" :src="course.cover_file" :alt="course.title">
              </v-col>
              <v-col cols="12" v-if="course.sub_title">
                {{ course.sub_title }}
              </v-col>
              <v-col cols="12" v-if="course.description">
                {{ course.description }}
              </v-col>
              <v-col cols="12" v-if="course.details">
                {{ course.details }}
              </v-col>
              <v-col cols="12">
                زمان دوره : {{ course.duration }} ماه
              </v-col>
              <v-col cols="12">
                زمان ویدیو های دوره : {{ course.total_time }} دقیقه
              </v-col>
              <v-col cols="12" class="text-center">
                <v-btn color="#1ab69d" elevation="0" class="buy-btn"
                       @click="$router.push('/dashboard/course/buy/'+course.id)">
                  {{ Intl.NumberFormat('en-US').format(course.price) }} تومان
                  <v-icon color="white">mdi-cart</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import GlobalSnackBarMobile from "@/components/Components/Mobile/Notification/GlobalSnackBarMobile.vue";

export default {
  name: "CoursesMobile",
    components: {GlobalSnackBarMobile},
  data() {
    return {
      courses: []
    }
  },
  methods: {
    getCourses() {
      window.axios.get('course/crud/index?per_page=1000&visibility=1').then((res) => {
        this.courses = res.data.data.data
      }).catch((err) => {
          if (err.response.status === 400) {
              this.openSnackbar(err.response.data.message, '#F1416C')
          }
      })
    }
  },
  mounted() {
    this.getCourses()
  }
}
</script>

<style scoped>
.custom-margin-full-page {
  margin: 0 8vw 0 8vw;
}

.title-courses {
  margin-top: 5vh;
  margin-bottom: 3vh;
  font-size: 6vw !important;
}

.course-card {
  border-radius: 15px;
  background-color: #1ab69d;
}

.white-background {
  background-color: white;
}

.course-cover {
  border-radius: 15px;
}

.buy-btn {
  letter-spacing: normal;
  color: white;
  border-radius: 15px;
  width: 200px;
  padding: 25px !important;
}

.custom-shape-red-course {
  position: absolute;
  margin-right: -6vw;
  margin-top: -3vh;
}

.custom-shape-circle-red-course {
  transform: rotate(15deg);
  position: absolute;
  top: 6vh;
  right: 5vw;
}
</style>